import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { NavItem } from './types';
import { Profile } from '@/lib/types/core';
import UserMenu from './UserMenu';

interface DesktopNavigationProps {
  navItems: NavItem[];
  profile: Profile | null;
  loading: boolean;
  handleSignOut: () => void;
  setShowAuthModal: (show: boolean) => void;
  isScrolled: boolean;
}

const DesktopNavigation = ({
  navItems,
  profile,
  loading,
  handleSignOut,
  setShowAuthModal,
  isScrolled,
}: DesktopNavigationProps) => {

  const renderUserMenu = () => {
    return (
      <UserMenu 
        profile={profile}
        loading={loading}
        handleSignOut={handleSignOut}
        setShowAuthModal={setShowAuthModal}
      />
    );
  };

  return (
    <nav className="hidden md:flex items-center space-x-6">
      {navItems.map((item) => (
        <NavLink
          key={item.path}
          to={item.path}
          className={({ isActive }) =>
            `text-sm font-medium transition-colors hover:text-adv-orange ${
              isActive 
                ? 'text-adv-orange' 
                : isScrolled ? 'text-adv-dark' : 'text-white'
            }`
          }
        >
          {item.label}
        </NavLink>
      ))}
      <NavLink to="/explore-rides" className="btn-primary">
        Find a Ride
      </NavLink>
      
      {renderUserMenu()}
    </nav>
  );
};

export default DesktopNavigation;
